module.exports = __webpack_public_path__ + "static/media/IconAppealingActive.bd4a2aee.svg";